<template>
  <div>
    <el-row>
      <el-col :span="18">
        <el-button type="primary" @click="add" icon="el-icon-plus"
          v-if="this.currentMenuOperations.some(func => func.name.includes('addItem'))">新增</el-button>
      </el-col>
      <el-col :span="6" style="float: right;">
        <el-input v-model="search" placeholder="搜索" @input="getTables"></el-input>
      </el-col>
    </el-row>
    <el-table
      :data="tables"
      :default-sort="{prop: 'id', order: 'descending'}"
      tooltip-effect="light"
      style="width: 100%"
    >
      <el-table-column align="center" prop="id" label="ID"></el-table-column>
      <el-table-column align="center" prop="alias" label="别名"></el-table-column>
      <el-table-column align="center" prop="version" label="版本号"></el-table-column>
      <el-table-column align="center" label="操作" v-if="listOperations.length > 0">
        <template v-slot="{row}">

          <!-- <el-button size="mini" type="primary" @click="upgrade(row)">升级</el-button> -->
          <!-- <el-button  size="mini" type="primary" @click="edit(row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="del(row)">删除</el-button> -->
          <el-button v-for="btn in listOperations" :key="btn.id"
            size="mini"
            :type="btn.name.includes('del') ? 'danger' : 'primary'"
            @click="go(btn, row)"
          >{{btn.alias}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { Loading } from "element-ui";
export default {
  name: "ArrangeList",
  data: vm => ({
    search: null,
    tables: [],
    currentPage: 1,
    pageSize: 10,
    totalElement: 0
  }),
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
  },
  created(){
    this.getListOperations('arrangelist')
    if(!this.currentMenu){
      return
    }
    this.getTables()
  },
  methods: {
    ...mapMutations(['getListOperations']),
    go(btn, row){
      this[btn.name](row)
    },
    add() {
        this.$router.push({
            path: 'arrage'
        })
    },
    // 编辑
    instance2_edit_layout( row ) {
      this.$router.push({
        name: 'deployarrage',
        params: {
          type: 'edit',
          id: row.id,
        }
      })
    },
    // 升级
    upgrade( row ){
      this.$router.push({
        name: 'deployarrage',
        params: {
          type: 'upgrade',
          id: row.id
        }
      })
    },
    instance2_del(row) {
      this.$confirm('您确定要删除id为' + row.id +'编排吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
         this.$axios
          .get(this.baseUrl3 + "instance2/del/" + row.id)
          .then(({ data: { msg, data, code } }) => {
            if (code == 20000) {
              this.getTables(false);
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              this.$message({ showClose: true, message: msg, type: "error" });
              console.log(msg);
            }
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: "系统异常",
              type: "error"
            });
            console.log(error);
          });
        }).catch(() => {
        });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getTables()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTables()
    },
    getTables(tooltip){
      let loading
      if(tooltip != false){
        loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
      }

          this.$axios.get(this.baseUrl3 + 'instance2/findByPageLike/'
                          + this.currentPage + '/' + this.pageSize + '/' + this.search)
            .then(({data: {code, data, msg}})=>{
              tooltip != false ? loading.close() : true
                if(code == 20000){
                    this.tables = data.list
                    this.totalElement = data.total
                }else{
                    this.$message.error('查询列表失败,' + msg)
                }
            })
            .catch( err => {
              tooltip != false ? loading.close() : true
                console.log(err)
            })
    },
    // 查看编排下的实例列表
    instance2_list(row){
      this.$router.push({
        name: 'deployinstancelist',
        params: {
          type: 'arrange',
          id: row.id,
        }
      })
    }
  }
};
</script>
